import React from 'react'
import PropTypes from 'prop-types'

// Components
import {Component} from '@salesforce/commerce-sdk-react/components'
import {Divider, VStack} from '@salesforce/retail-react-app/app/components/shared/ui'

export const PDCDeliveryOptionsContainer = ({regions}) => {
    const components = regions?.[0]?.components ?? []

    return (
        <VStack
            paddingInline={{base: 10, md: 40}}
            paddingBlock={{base: 20, md: 30}}
            gap={16}
            alignItems="stretch"
        >
            {components.map((component) => (
                <>
                    <Divider borderColor="borderGray" />
                    <Component key={component.id} component={component} />
                </>
            ))}

            <Divider borderColor="borderGray" />
        </VStack>
    )
}

PDCDeliveryOptionsContainer.propTypes = {
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            components: PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.shape({
                        deliveryOptionTitle: PropTypes.string,
                        deliveryOptionColumnOne: PropTypes.string,
                        deliveryOptionColumnTwo: PropTypes.string
                    }),
                    id: PropTypes.string,
                    typeId: PropTypes.string
                })
            )
        })
    )
}
